import uuid from 'uuid/v1';
import { promiseError } from '@/store/utils';
import vendorService, { IVendor } from '@/services/vendor';

interface IResourceVendor {
  id: string;
  vendor: IVendor;
  properties: {
    [key: string]: string;
  };
}

interface IState {
  allVendors: IVendor[];
  resourceVendors: IResourceVendor[];
}

export default () => ({
  namespaced: true,
  state: () => ({
    allVendors: [],
    resourceVendors: [],
  }),
  mutations: {
    ADD_VENDOR_TO_RESOURCE(state: IState, vendor: any = {}) {
      state.resourceVendors = (state.resourceVendors || []).concat({
        id: uuid(),
        properties: [],
        vendor,
      } as any);
    },
    CREATE_VENDOR(state: IState, vendor: IVendor) {
      state.allVendors = state.allVendors.concat(vendor);
    },
    LOAD_VENDORS(state: IState, allVendors: IVendor[] = []) {
      state.allVendors = allVendors;
    },
    UPDATE_RESOURCE_VENDORS(state: IState, vendors: IResourceVendor[]) {
      state.resourceVendors = vendors;
    },
  },
  actions: {
    addVendorToResource: ({ commit }: any) => {
      commit('ADD_VENDOR_TO_RESOURCE');
    },
    createVendor: (
      { commit }: any,
      { name, resourceId, resourceType }: any,
    ) => (
      vendorService
        .create({
          name,
          // create vendor resources
          [resourceType + 's']: {
            data: [{
              [resourceType + '_id']: resourceId,
            }],
          },
        })
        .then((newVendor: any) => {
          const vendor = { id: newVendor.id, name };
          commit('CREATE_VENDOR', vendor);
          commit('ADD_VENDOR_TO_RESOURCE', vendor);
          return newVendor;
        })
    ),
    loadVendors: ({ commit }: any) => {
      // load all vendors
      vendorService
        .find(`id, name`)
        .then(response => commit('LOAD_VENDORS', response.result))
        .catch(promiseError(`VENDORS_LOAD`, commit));
    },
    updateResourceVendors: (
      { commit }: any,
      vendors: IResourceVendor[],
    ) => {
      commit('UPDATE_RESOURCE_VENDORS', vendors);
    },
  },
});
